module.exports = __webpack_public_path__ + "img/Bahnhof_Oravita_2kl.efe59b27.jpg";